/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A3Inputs */

const et_faq_a3 = /** @type {(inputs: Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilus koduleht ei too päringuid, kui see ei vasta kliendi ostuküsimustele, ei ole Google'is nähtav või ei juhi külastajat selgelt järgmise sammuni. Sellisel juhul on veebileht pigem digitaalne visiitkaart kui müügikanal. ScalingWebs ehitab veebilehti, mis keskenduvad nähtavusele, usaldusele ja konversioonile. See tähendab selget pakkumist, kiiret laadimist, tugevat sõnumit, SEO-struktuuri, sotsiaalset tõestust ja vorme või automaatikaid, mis aitavad külastajast päringu teha.`)
};

const en_faq_a3 = /** @type {(inputs: Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A beautiful website won't generate inquiries if it doesn't answer buyer questions, isn't visible on Google, or doesn't clearly guide visitors to the next step. In that case, the site is more of a digital business card than a sales channel. ScalingWebs builds websites focused on visibility, trust, and conversion. That means a clear offer, fast loading, strong messaging, SEO structure, social proof, and forms or automations that help turn visitors into inquiries.`)
};

/**
* | output |
* | --- |
* | "A beautiful website won't generate inquiries if it doesn't answer buyer questions, isn't visible on Google, or doesn't clearly guide visitors to the next ste..." |
*
* @param {Faq_A3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a3 = /** @type {((inputs?: Faq_A3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a3(inputs)
	return en_faq_a3(inputs)
});